import React, {Component} from 'react';
// import { Row, Col, FormControl } from 'react-bootstrap';
// import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
// import Moment, { defaultFormat } from 'moment';
import ReportStore from '../../stores/ReportStore'

const DEFAULT_ROW = 46
class PrintReportPickup extends Component {

  constructor(...args){
    super(...args)
    this.state = {data:[],dataList:[],report_title:'กำลังดึงข้อมูล..'}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData(this.props.year,this.props.month,this.props.name)
  }

  loadData(year='',month='',name='') {
    // let {data} = this.state
    ReportStore.loadAllYearEmpStockMonth(year,month,name,(result) => {
      this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
    })
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  getTextMonth() {
    let month = this.props.month
    return month=='01'||month=='1' ? 'มกราคม' : month=='02'||month=='2' ? 'กุมภาพันธ์' : month=='03'||month=='3' ? 'มีนาคม' : month=='04'||month=='4' ? 'เมษายน' : month=='05'||month=='5' ? 'พฤษภาคม' : month=='06'||month=='6' ? 'มิถุนายน' : month=='07'||month=='7' ? 'กรกฎาคม' : month=='08'||month=='8' ? 'สิงหาคม' : month=='09'||month=='9' ? 'กันยายน' : month=='10' ? 'ตุลาคม' : month=='11' ? 'พฤศจิกายน' : month=='12' ? 'ธันวาคม' : ''
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renderItemList(items) {
    if (items.length===0) {
      return('')
    } else {
      return(
        items.map((item,index)=> {
          return(
            <div key={index} style={{width:'200px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
              - {item.description} จำนวน {item.quantity}
            </div>
          )
        })
      )
    }
  }

  renderRowData(items,indexs) {
    if (items.length===0) {
      return(
        <tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>
      )
    } else {
      return(
        items.map((item,index)=> {
          return(
            <tr key={index}>
              <td className='text-center'>{item.item.added_date.substr(0,10)}</td>
              <td className='text-center'>{item.item.added_date.substr(11,19)}</td>
              <td className='text-center'>{item.item.request_by}</td>
              <td className='text-center'>{item.item.car_registration_no}</td>
              <td className='text-center'>{item.item.work_no}</td>
              <td>{this.renderItemList(item.itemList)}</td>
              <td className='text-right'>{this.getNumberFormat(item.item.cost_stock)}</td>
            </tr>
          )
        })
      )    
    }
  }

  renderComponentPage(items,indexs,length) {
    return(
      <div className='font-print' key={indexs}>
        <header style={{textAlign:'center',marginBottom:'10px'}}>
          <h2>{this.props.title + ' ชื่อ ' + this.props.name + ' ประจำปี ' + this.props.year + ' เดือน ' + this.getTextMonth()}</h2>
        </header>
        <div className='font-18'>   
          <table className='table table-print-report-cashflow'>   
            <tbody>
              <tr>
                <td className='text-center' style={{ width: '90px' }}>วันที่</td>
                <td className='text-center' style={{ width: '70px' }}>เวลา</td>
                <td className='text-center' style={{ width: '150px' }}>ชื่อพนักงาน</td>
                <td className='text-center' style={{ width: '100px' }}>ทะเบียน</td>
                <td className='text-center' style={{ width: '100px' }}>ใบงาน</td>
                <td className='text-center'>รายการเบิก</td>
                <td className='text-center' style={{ width: '80px' }}>ต้นทุน</td>
              </tr>  
              {this.renderRowData(items,indexs)} 
              {length-1===indexs?
              <tr>
                <td colSpan={6} className='text-right'>ยอดรวมสุทธิ</td>
                <td className='text-right'>{this.getNumberFormat(this.getSummary('cost_stock'))}</td>
              </tr>
              :''}
            </tbody>
          </table> 
        </div>
      </div>  
    )
  }

  getPagination(data) {
    let itemList = []
    let newData = []
    let allData = []
    let checkRow = 0
    data.forEach(function(item,index) {
      if (checkRow<DEFAULT_ROW) {
        checkRow++
        item.items.forEach(function(_item,_index) { 
          if (_index>0) {
            if (checkRow<DEFAULT_ROW) {
              checkRow++
              itemList.push(_item)
            }  
            if (checkRow===DEFAULT_ROW-1||_index===item.items.length-1) {
              newData.push({
                item:item,
                itemList:itemList
              })
              itemList = []
              if (checkRow===DEFAULT_ROW-1) {
                allData.push(newData)
                checkRow = 0
                newData = []
                itemList = []
              }
            }  
          } else {
            itemList.push(_item)
            if (checkRow===DEFAULT_ROW-1||_index===item.items.length-1) {
              newData.push({
                item:item,
                itemList:itemList
              })
              itemList = []
              if (checkRow===DEFAULT_ROW-1) {
                allData.push(newData)
                checkRow = 0
                newData = []
                itemList = []
              }
            }
          }
        })
      }  

      if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
        allData.push(newData)
        checkRow = 0
        newData = []
      }
    })
    return allData
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {loading,dataList} = this.state
    if (dataList.length===0) {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title}
        >
          {this.renderNoData()}
        </PrintPreview>
      )  
    } else {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title}
        >
          {
            dataList.map((item,index) => {
              return this.renderComponentPage(item,index,dataList.length)
            })  
          }
        </PrintPreview>
      )
    }  
  }
}  

PrintReportPickup.defaultProps = {
  title: 'รายการเบิกอะไหล่',  
  mode : '1'
}
export default PrintReportPickup;


// WEBPACK FOOTER //
// ./src/view/print/PrintReportPickup.js